import type { FaireProductEntity } from "../../entity_types/product";

export const p_4snrc2q249: FaireProductEntity = {
  token: "p_4snrc2q249",
  type: "product",
  name: "Rare Genuine Citrine Sphere with Tripod - AAA Premium Quality",
  brandToken: "b_92q2hhsl",
  brandName: "Tiny Rituals",
  imageUrl:
    "https://cdn.faire.com/fastly/d5513fd700a681c191a00856b5c0e8b657c9b4e494fb87dc4e9fed97e5ef6607.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1169a07f5c530655e50f09903bc97e1aececdcbdc7d7204bb648f273543a6b0b.jpeg",
    "https://cdn.faire.com/fastly/7110483033548de08d4a7036c1fb278976c955230f78134de2a7ac9a994854b0.png",
    "https://cdn.faire.com/fastly/312ca7afe269af7730071daed10cf72fd54a0ed091b617ed6e201912b96556bf.jpeg",
  ],
  priceDollars: 246.5,
  description:
    "Abundance, joy, and the pure power of sunlit possibility are captured in this globe-like shape of the Citrine Sphere. Shimmering with summer moods and magic, this feel-good sphere is a sweet reminder that things will be better than OK; they will be amazing. <br /> With this sphere, I welcome a whole world of possibility and positivity to brighten the way. <br />Description<br />With its lemon-like lilt and lovely energy, the Citrine Sphere is the confidence-boosting mascot you need. Ever ready to bring sunshine to your style, Citrine crystals are known for being a magnet of prosperity and abundance. Throwing out all the highest vibrations pulls luck in your direction, which is why it gets its nickname as  the merchant stone. ' <br />Citrine's meaning is peppered with possibility and positivity. Like all yellow crystals, it connects to the sacral and solar plexus chakras. This means it can turn up the dial on your sense of self-worth and confidence. It also taps into those deep wells of",
  tags: [],
  msrpDollars: 493,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:32.551Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
